export default __webpack_public_path__ + "static/logo-a8aae5a4c0eafc2c6d25d2e66726c2d6.png";